<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box lite_popup_box_confirm_mysql">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ $t('language.popup.warning') }}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="cancel"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <div>{{ $t('language.common.overwriteTip') }}</div>
            </div>
            <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button class="white" @click="cancel">{{ $t('language.common.cancel') }}</button>
                <button ref="okBtn" @keyup.esc="show = false" @keyup.enter="ok" @click="ok">{{ $t('language.common.continue') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
        };
    },
    watch: {
        show(val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.okBtn.focus();
                });
            }
        }
    },
    methods: {
        ok() {
            this.show = false
            this.$emit('ok');
        },
        cancel() {
            this.show = false
            this.$emit('cancel');
        },
    }
};
</script>

<style>
/* 弹窗宽度 */
.lite_popup_box.lite_popup_box_confirm_mysql {
    width: 620px;
}
/* 弹窗内容高度 */
.lite_popup_box.lite_popup_box_confirm_mysql .lite_popup_content {
    height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_confirm_mysql.vue